<div>test view grade age instersect</div><!--
<div class="row" id="searchResults" ng-init="initSort()">-->
    <!-- Search Results -->
<!--    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <legend>
            {{students.length}} Children
            <span class="pull-right">
                <div class="form-group" style="width:200px;">
                    <div class="input-group" ng-show="!hideItemsPerPage">
                        <div class="input-group-addon">
                            {{$root.ROWS_PER_PAGE}}
                        </div>
                        <select name="itemsPerPage" ng-model="itemsPerPage" class="form-control" required>
                            <option value="5" ng-selected="itemsPerPage == 5">5</option>
                            <option value="10" ng-selected="itemsPerPage == 10">10</option>
                            <option value="25" ng-selected="itemsPerPage == 25">25</option>
                            <option value="50" ng-selected="itemsPerPage == 50">50</option>
                            <option value="100" ng-selected="itemsPerPage == 100">100</option>
                            <option value="9999999" ng-selected="itemsPerPage == 9999999">All</option>
                        </select>
                    </div>
                </div>
            </span>
        </legend>
        <div>

            <h4 ng-if="grade">Grade: <span class="bind-color">{{grade}}</span></h4>
            <h4 ng-if="age">Age on 9/1/{{schoolYear.current}}: <span class="bind-color">{{age}}</span></h4>
            <div class="table-responsive" ng-if="students.length > 0">
                <div class="input-group">
                    <div class="input-group-addon">Filter</div>
                    <input class="form-control" type="text" ng-model="filter" placeholder="Filter items below" />
                </div>
                <table class="table table-default">
                    <thead>
                        <tr>
                            <th ng-class="{ 'cursor-pointer': obj.SORT.length > 0 }" ng-click="obj.SORT.length > 0 ? setSort(obj.SORT, true) : null" ng-repeat="(column, obj) in columns" ng-if="(exportingExcel ? obj.ENABLED : obj.ENABLED && !obj.EXCEL_EXPORT_ONLY) && (obj.DISABLED ? true : obj.ENABLED)"
                                ng-mouseenter="columns[column].TOOLTIP_OPEN = true;"
                                ng-mouseleave="columns[column].TOOLTIP_OPEN = false;">
                                <span uib-popover-html="'{{obj.TOOLTIP}}'"
                                      popover-is-open="columns[column].TOOLTIP_OPEN"
                                      popover-trigger="'outsideClick'"
                                      popover-placement="top"
                                      popover-enable="obj.TOOLTIP.length > 0">
                                    {{column}}
                                </span>
                                <span class="fa fa-fw" ng-class="{ 'fa-sort':currentSortValue != obj.SORT && obj.SORT.length > 0, 'fa-chevron-up':!reverse && currentSortValue === obj.SORT, 'fa-chevron-down':reverse && currentSortValue === obj.SORT }"></span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr dir-paginate="student in students | filter:filter | orderBy:[currentSortValue, currentSecondarySortValue]:reverse | itemsPerPage: itemsPerPage"
                            pagination-id="'studentsByEligibilityCategory'"
                            current-page="currentPage"
                            ng-class="{'danger': student.STUDENT_TERMINATION_STATUSES.length > 0 && student.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
                            uib-tooltip-html="'{{student.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE}}'"
                            tooltip-enable="student.STUDENT_TERMINATION_STATUSES.length > 0 && student.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.ID !== 1"
                            tooltip-placement="auto top"
                            tooltip-append-to-body="true">
                            <td ng-if="!columns['MSD Number'].EXCEL_EXPORT_ONLY && columns['MSD Number'].DISABLED ? true : (columns['MSD Number'].ENABLED)">
                                <span ng-if="exportingExcel">'{{student.MSD_NUMBER}}</span>
                                <edit-student-btn student="student" size="'msd'" disable-refresh="false" ng-if="!exportingExcel"></edit-student-btn>
                            </td>
                            <td ng-if="!columns['SSID'].EXCEL_EXPORT_ONLY && columns['SSID'].DISABLED ? true : (columns['SSID'].ENABLED)">
                                {{student.SSID}}
                            </td>



                            <td ng-if="!columns['Name'].EXCEL_EXPORT_ONLY && columns['Name'].DISABLED ? true : (columns['Name'].ENABLED)">
                                <span ng-if="!student.PERSON.SECOND_LAST_NAME">{{student.PERSON.LAST_NAME | titleText}},</span>
                                <span ng-if="student.PERSON.SECOND_LAST_NAME">{{student.PERSON.LAST_NAME | titleText}} {{student.PERSON.SECOND_LAST_NAME | titleText}},</span>
                                {{student.PERSON.FIRST_NAME | titleText}} {{student.PERSON.MIDDLE_INITIAL | titleText}}
                            </td>

                            <td ng-if="!columns['Grade'].EXCEL_EXPORT_ONLY && columns['Grade'].DISABLED ? true : (columns['Grade'].ENABLED)">
                                <view-multiple-objects objects="student.SCHOOL_ENROLLMENT_DETAILS" target="'GRADE'" show-all="true"></view-multiple-objects>
                            </td>

                            <td ng-if="!columns['DOB'].EXCEL_EXPORT_ONLY && columns['DOB'].DISABLED ? true : (columns['DOB'].ENABLED)">
                                {{student?.DOB | simpleDate}}
                            </td>
                            <td ng-if="!columns['Age'].EXCEL_EXPORT_ONLY && columns['Age'].DISABLED ? true : (columns['Age'].ENABLED)">
                                {{student?.AGE}}
                            </td>
                            <td ng-if="!columns['Enroll Date'].EXCEL_EXPORT_ONLY && columns['Enroll Date'].DISABLED ? true : (columns['Enroll Date'].ENABLED)">
                                {{student?.SCHOOL_ENROLLMENT_DETAILS[0]?.ENROLLMENT_DATE | simpleDate}}
                            </td>
                            <td ng-if="!columns['Source'].EXCEL_EXPORT_ONLY && columns['Source'].DISABLED ? true : (columns['Source'].ENABLED)">
                                {{student?.SCHOOL_ENROLLMENT_DETAILS[0]?.SOURCE}}
                            </td>-->
                            <!--<td ng-if="!columns['Gender'].EXCEL_EXPORT_ONLY && columns['Gender'].DISABLED ? true : (columns['Gender'].ENABLED)">
                                {{student.SEX}}
                            </td>-->
<!--
                        </tr>

                    </tbody>
                </table>







                <div class="text-center" ng-if="students.length > 0">-->
      <!--              <dir-pagination-controls boundary-links="true" auto-hide="true" pagination-id="'studentsByEligibilityCategory'"></dir-pagination-controls> -->
       <!--         </div>
            </div>


            <div class="text-center">
                <span ng-if="loading && !loaded"><i class="fa fa-lg fa-spin fa-refresh fa-fw"></i> {{loadingStatus}}</span>
            </div>
        </div>

        <div class="well" ng-show="noResults">
            <span>
                No Search Results &nbsp;
            </span>
        </div>
    </div>
</div>-->


